<div style="height: 100%; position: relative; z-index: 100">
  <ngx-loading
    [show]="loading"
    [config]="{
      backdropBorderRadius: '3px',
      animationType: ngxLoadingAnimationTypes.circle,
      primaryColour: this.primaryColour,
      secondaryColour: this.secondaryColour
    }">
  </ngx-loading>
  <div
    style="height: 98%"
    leaflet
    (leafletMapReady)="onMapReady($event)"
    [leafletOptions]="lOptions"
    [leafletLayers]="lLayers"></div>

  <div *ngIf="!hideVersionSelect" style="position: absolute; top: 10px; right: 10px; z-index: 900">
    <select *ngIf="!hideWriteControls && versions?.length > 1" [(ngModel)]="selectedVersion" class="version-select">
      <option *ngFor="let version of versions; let i = index" [ngValue]="version">Version {{ i + 1 }}</option>
    </select>
  </div>
</div>

<div style="display: none; position: relative" #flagTemplate>
  <div class="flag-icon">
    <i class="fa fa-flag"></i>
  </div>
  <div class="flag-tooltip">
    <span class="flag-type" style="color: #eee; font-weight: bold"></span>
    <br />
    <span class="flag-text" style="color: #ddd; overflow-wrap: break-word"></span>
    <br />
    <span class="flag-warning-tooltip" style="color: #ddd"></span>
  </div>
</div>

<app-add-flag #addFlagModal></app-add-flag>
<app-edit-flag #editFlagModal></app-edit-flag>
